import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_DESTINATIONS = "fetchAdminDestinations";

// mutation types
export const SET_ADMIN_DESTINATIONS = "setAdminDestinations";
export const SET_ADMIN_DESTINATIONS_PAGINATION =
  "setAdminDestinationsPagination";

const state = {
  adminDestinations: [],
  adminDestinationsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  adminDestinations(state) {
    return state.adminDestinations;
  },
  adminDestinationsPagination(state) {
    return state.adminDestinationsPagination;
  }
};

const actions = {
  [FETCH_ADMIN_DESTINATIONS](context, name = null) {
    let params = {
      page: context.state.adminDestinationsPagination.currentPage
    };
    if (name) {
      params.name = name;
    }
    return new Promise((resolve, reject) => {
      ApiService.query("admin/destinations", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_DESTINATIONS, data.data);
          context.commit(SET_ADMIN_DESTINATIONS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ADMIN_DESTINATIONS](state, adminDestinations) {
    state.adminDestinations = adminDestinations;
  },
  [SET_ADMIN_DESTINATIONS_PAGINATION](state, data) {
    state.adminDestinationsPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
